export const FETCH_SITE_REQUEST = 'landing/FETCH_SITE_REQUEST';
export const FETCH_SITE_SUCCESS = 'landing/FETCH_SITE_SUCCESS';
export const FETCH_SITE_FAILURE = 'landing/FETCH_SITE_FAILURE';

export const LAYOUT_PAGE_KEY = 'layout';
